window.addEventListener('load', function() {
	// Remove visibility: hidden; for CLS
	document.body.style = '';
});

var jsLoaded = false,
		mui = false,
		loadJS = function() {
			if(!jsLoaded) {
				var script = document.querySelector('script[data-src]');

				if(script) {
					script.src = script.dataset.src;
					script.removeAttribute('data-src');
					script.addEventListener('load', loadJS);
				} else {
					jsLoaded = true;
				}
			}

			// Minimal User Interaction
			if(!mui) {
				if(typeof dataLayer !== 'undefined') {
					dataLayer.push({ 'event': 'minimal-user-interaction' });
				}

				mui = true;
			}
		};

document.addEventListener('focus', loadJS, { once: true });
document.addEventListener('mousemove', loadJS, { once: true });
document.addEventListener('scroll', loadJS, { once: true });
document.addEventListener('touchstart', loadJS, { once: true });
document.addEventListener('keydown', loadJS, { once: true });